import { useRef } from "react";
import './ContactCss/Modal.css';

function Fail(props){
    const modalRef = useRef();
    const modalOutClick = (e) => {
        if(modalRef.current === e.target){
            props.setVal('')
        }
    }

    return(
        <div className="valid" ref={modalRef} onClick={(e)=>{modalOutClick(e)}}>
            <div className="valid-modal">
                <div className="valid-modal-all">
                    <p className="valid-modal-font">입력칸 및 개인정보 동의여부를 확인해주세요.</p>
                    <div className="valid-modal-button">
                        <button className="valid-modal-check" onClick={()=>{props.setVal('')}}>
                            확인
                        </button>
                    </div>
                </div>
            </div>            
        </div>        
    )
}

export default Fail;